export default __webpack_public_path__ + "static/media/white360.526cf359.gif";